import {
	ApplicationConfig,
	importProvidersFrom,
	InjectionToken,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
	HTTP_INTERCEPTORS,
	HttpClient,
	provideHttpClient,
	withFetch,
} from '@angular/common/http';
import {
	BrowserModule,
	provideClientHydration,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalInterceptor,
	MsalService,
} from '@azure/msal-angular';
import { environment } from '@case-management/environments/environment';
import { routes } from './app.routes';
// import { AuthInterceptor } from './auth-interceptor';
import {
	provideTranslationOnDemand,
	TodLogLevel,
	withDefaultLocale,
	withJoinChar,
	withLabelEndpoint,
	withLocaleFromMessageEvent,
	withLocaleFromQueryParam,
	withLogging,
} from '@my-ul/tod-angular-client';
import { MaterialModule } from './module/material-module/material-module.module';
import { MSALGuardConfigFactory } from './msal-guard.factory';
import { MSALInstanceFactory } from './msal-instance.factory';
import { MSALInterceptorConfigFactory } from './msal-interceptor-config.factory';

interface LocaleChange {
	event: 'localeChange';
	locale: string;
}

export const LOCAL_STORAGE_VALUE = new InjectionToken<string>(
	'LOCAL_STORAGE_VALUE',
);

export function getLocaleFromLocalStorage(): string {
	console.log(localStorage.getItem('selectedLocale'));
	return localStorage.getItem('selectedLocale') || 'en-US';
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideClientHydration(),
		provideHttpClient(withFetch()),
		...environment.providers,
		importProvidersFrom(BrowserModule, MaterialModule, HttpClient),
		provideAnimations(),
		provideTranslationOnDemand(
			withDefaultLocale(getLocaleFromLocalStorage()),
			withLabelEndpoint(environment.translationEndPoint),
			withJoinChar('^'),
			withLocaleFromQueryParam('locale'),
			withLogging(TodLogLevel.Debug),
			withLocaleFromMessageEvent<LocaleChange>(
				(
					event: MessageEvent<unknown>,
				): event is MessageEvent<LocaleChange> => {
					console.log(event);
					return (
						!!event.data &&
						typeof event.data === 'object' &&
						'event' in event.data &&
						event.data['event'] === 'localeChange' &&
						'locale' in event.data
					);
				},
				(data) => {
					console.log('setting locale', data.locale);
					return data.locale;
				},
			),
		),
		MsalService,
		MsalBroadcastService,
		MsalGuard,
		{
			provide: HTTP_INTERCEPTORS, // Provides as HTTP Interceptor
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
		},
		// {
		// 	provide: HTTP_INTERCEPTORS,
		// 	useClass: AuthInterceptor,
		// 	multi: true,
		// },
	],
};
